import yup from 'utils/yup';

const validationSchema = yup.object({
  additionalLinks: yup
    .array()
    .of(
      yup.object({
        link: yup.string().nullable().trim().websiteURL(),
      }),
    )
    .default([]),
});

export default validationSchema;
